<div *ngIf="!hide" class="select-option" [class.active]="selected && !multipleSelect" [attr.selectedid]="selectedid">
    <span>
        <cmx-checkbox class="cmx-checkbox" *ngIf="multipleSelect" 
            [checked]="selected">
        </cmx-checkbox>
        <ng-content></ng-content>
    </span>
</div>